
import { QuotationList } from 'components/QuotationList/QuotationList';

export default function Main() {
  return (
    <>
      <QuotationList />
    </>
  );
}
// Main.propTypes = {
//   author: PropTypes.string.isRequired,
//   quotation: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
// };
